import { Button, Link, Text } from 'native-base'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { STRAPI_API_URL } from '../../constants/config'

import { GoogleIcon } from './GoogleIcon'

export const AuthContinueWithGoogleButton = () => {
  const { t } = useTranslation()

  return (
    <Link href={`${STRAPI_API_URL}/api/connect/google`} textDecoration="none">
      <Button
        borderColor={'gray.700'}
        variant="outline"
        testID={`social-network-button-google`}
        height="48px"
        width="full"
        mt={2}
        leftIcon={<GoogleIcon />}
      >
        <Text ml={'3px'} fontSize={'md'} fontWeight={'bold'} color={'primary.500'}>
          {t('screens.createAccountProfile.continueWith', { type: 'Google' })}
        </Text>
      </Button>
    </Link>
  )
}
